import React from 'react';

import {Provider} from "react-redux";

import SentListContainer from "./container/SentListContainer";

import configure from '../../store/configure';
import Layout from "../../component/layout/Layout";

const SentListPage = () => {
    return (
        <Provider store={configure}>
            <Layout>
                <SentListContainer/>
            </Layout>
        </Provider>
    );
};

export default SentListPage;
